import client from './client';

export function getSrhtCourseReferenceOptions() {
  return client.get('/api/srht-courses/reference/options');
}

export function getSrhtCourses() {
  return client.get('/api/srht-courses/courses');
}

export function getSrhtCourse(courseId) {
  return client.get(`/api/srht-courses/courses/${courseId}`);
}

export function createSrhtCourse(data) {
  return client.post('/api/srht-courses/courses', data);
}

export function updateSrhtCourse(courseId, data) {
  return client.put(`/api/srht-courses/courses/${courseId}`, data);
}

export function closeSrhtCourse(courseId) {
  return client.post(`/api/srht-courses/courses/${courseId}/close`);
}

export function unlockSrhtCourse(courseId, data) {
  return client.post(`/api/srht-courses/courses/${courseId}/unlock`, data);
}

export function deleteSrhtCourse(courseId) {
  return client.delete(`/api/srht-courses/courses/${courseId}`);
}

export function exportSrhtCoursePdf(courseId, data = {}) {
  return client.post(`/api/srht-courses/courses/${courseId}/export-pdf`, data, {
    responseType: 'blob',
  });
}

export function saveSrhtCandidateFeedback(courseId, courseDayId, data) {
  return client.put(`/api/srht-courses/courses/${courseId}/days/${courseDayId}/candidate-feedback`, data);
}

export function finalizeSrhtCandidateFeedback(courseId, courseDayId) {
  return client.post(`/api/srht-courses/courses/${courseId}/days/${courseDayId}/candidate-feedback/finalize`);
}

export function unlockSrhtCandidateFeedback(courseId, courseDayId) {
  return client.post(`/api/srht-courses/courses/${courseId}/days/${courseDayId}/candidate-feedback/unlock`);
}

export function saveSrhtInstructorFeedback(courseId, courseDayId, data) {
  return client.put(`/api/srht-courses/courses/${courseId}/days/${courseDayId}/instructor-feedback`, data);
}

export function finalizeSrhtInstructorFeedback(courseId, courseDayId) {
  return client.post(`/api/srht-courses/courses/${courseId}/days/${courseDayId}/instructor-feedback/finalize`);
}

export function unlockSrhtInstructorFeedback(courseId, courseDayId, data) {
  return client.post(`/api/srht-courses/courses/${courseId}/days/${courseDayId}/instructor-feedback/unlock`, data);
}

export function saveSrhtDayReviews(courseId, courseDayId, data) {
  return client.put(`/api/srht-courses/courses/${courseId}/days/${courseDayId}/reviews`, data);
}

export function withdrawSrhtParticipant(courseId, participantId, data) {
  return client.post(`/api/srht-courses/courses/${courseId}/participants/${participantId}/withdraw`, data);
}

export function reinstateSrhtParticipant(courseId, participantId) {
  return client.post(`/api/srht-courses/courses/${courseId}/participants/${participantId}/reinstate`);
}

export function saveSrhtParticipantExclusion(courseId, participantId, data) {
  return client.put(`/api/srht-courses/courses/${courseId}/participants/${participantId}/exclusion`, data);
}

export function finalizeSrhtParticipantExclusion(courseId, participantId) {
  return client.post(`/api/srht-courses/courses/${courseId}/participants/${participantId}/exclusion/finalize`);
}

export function unlockSrhtParticipantExclusion(courseId, participantId, data) {
  return client.post(`/api/srht-courses/courses/${courseId}/participants/${participantId}/exclusion/unlock`, data);
}

export function exportSrhtParticipantExclusionPdf(courseId, participantId) {
  return client.post(`/api/srht-courses/courses/${courseId}/participants/${participantId}/exclusion/export-pdf`, {}, {
    responseType: 'blob',
  });
}

export function getSrhtWeekOverview(courseId, weekNumber) {
  return client.get(`/api/srht-courses/courses/${courseId}/weeks/${weekNumber}`);
}

export function saveSrhtWeeklyEvaluation(courseId, participantId, weekNumber, data) {
  return client.put(`/api/srht-courses/courses/${courseId}/participants/${participantId}/weeks/${weekNumber}`, data);
}

export function finalizeSrhtWeeklyEvaluation(courseId, participantId, weekNumber) {
  return client.post(`/api/srht-courses/courses/${courseId}/participants/${participantId}/weeks/${weekNumber}/finalize`);
}

export function unlockSrhtWeeklyEvaluation(courseId, participantId, weekNumber, data) {
  return client.post(`/api/srht-courses/courses/${courseId}/participants/${participantId}/weeks/${weekNumber}/unlock`, data);
}